import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-object-dialog-recap',
  templateUrl: './object-dialog-recap.component.html',
  styleUrls: ['./object-dialog-recap.component.scss']
})
export class ObjectDialogRecapComponent implements OnInit {

  @Input() objectType!: string;
  @Input() object!: any;
  @Input() locale: string = 'fr';

  constructor() { }

  ngOnInit(): void {
    
  }

}
